import { DateField, TextField } from '@servicetitan/anvil2-react-hook-form';

interface MilitaryIDFieldsProps {
    fieldPrefix?: string;
}

export const MilitaryIDFields = ({ fieldPrefix = '' }: MilitaryIDFieldsProps) => {
    return (
        <>
            <TextField
                label="ID Number"
                name={[fieldPrefix, 'applicantId.documentId'].join('.')}
                required
            />
            <DateField
                label="Issue Date"
                name={[fieldPrefix, 'applicantId.issueDate'].join('.')}
                required
            />
            <DateField
                label="Expiration Date"
                name={[fieldPrefix, 'applicantId.expirationDate'].join('.')}
                required
            />
            <TextField
                label="Country"
                name={[fieldPrefix, 'applicantId.country'].join('.')}
                required
            />
            <TextField
                label="Issuer Name"
                name={[fieldPrefix, 'applicantId.issuerName'].join('.')}
                required
            />
        </>
    );
};
